import { blobticService } from '../../Commun/services/blobticService';

export interface Maintenance {
    id: number;
    uid: string;
    vehicleId: number;
    type: string;
    category: string;
    title: string;
    description?: string;
    scheduledDate?: Date;
    startDate?: Date;
    endDate?: Date;
    status: string;
    priority: string;
    cost?: number;
    vehicleRegistration?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface MaintenanceDto {
    MNT_IDF: number;
    MNT_UIDF: string;
    VEH_IDF: number;
    MNT_TYPE: string;
    MNT_CATEGORY: string;
    MNT_TITLE: string;
    MNT_DESCRIPTION?: string;
    MNT_SCHEDULED_DATE?: string;
    MNT_START_DATE?: string;
    MNT_END_DATE?: string;
    MNT_STATUS: string;
    MNT_PRIORITY: string;
    MNT_COST?: number;
    VEH_REGISTRATION?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: MaintenanceDto): Maintenance => ({
    id: dto.MNT_IDF,
    uid: dto.MNT_UIDF,
    vehicleId: dto.VEH_IDF,
    type: dto.MNT_TYPE,
    category: dto.MNT_CATEGORY,
    title: dto.MNT_TITLE,
    description: dto.MNT_DESCRIPTION,
    scheduledDate: dto.MNT_SCHEDULED_DATE ? new Date(dto.MNT_SCHEDULED_DATE) : undefined,
    startDate: dto.MNT_START_DATE ? new Date(dto.MNT_START_DATE) : undefined,
    endDate: dto.MNT_END_DATE ? new Date(dto.MNT_END_DATE) : undefined,
    status: dto.MNT_STATUS,
    priority: dto.MNT_PRIORITY,
    cost: dto.MNT_COST,
    vehicleRegistration: dto.VEH_REGISTRATION,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const maintenanceApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_maintenance,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<Maintenance>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_maintenance,Insert',
            VEH_IDF: data.vehicleId,
            MNT_TYPE: data.type,
            MNT_CATEGORY: data.category,
            MNT_TITLE: data.title,
            MNT_DESCRIPTION: data.description,
            MNT_SCHEDULED_DATE: data.scheduledDate?.toISOString(),
            MNT_START_DATE: data.startDate?.toISOString(),
            MNT_END_DATE: data.endDate?.toISOString(),
            MNT_STATUS: data.status || 'scheduled',
            MNT_PRIORITY: data.priority || 'medium',
            MNT_COST: data.cost
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<Maintenance>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_maintenance,Update',
            MNT_IDF: id,
            VEH_IDF: data.vehicleId,
            MNT_TYPE: data.type,
            MNT_CATEGORY: data.category,
            MNT_TITLE: data.title,
            MNT_DESCRIPTION: data.description,
            MNT_SCHEDULED_DATE: data.scheduledDate?.toISOString(),
            MNT_START_DATE: data.startDate?.toISOString(),
            MNT_END_DATE: data.endDate?.toISOString(),
            MNT_STATUS: data.status,
            MNT_PRIORITY: data.priority,
            MNT_COST: data.cost
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_maintenance,Delete', MNT_IDF: id }
        });
        return response;
    }
};
